import regionApi from '~/clientApis/regionApi';
import { getStore } from '~/mobx/AppStore';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { CreateCategoryRequest } from '@bluestone-node-sdk/pim';

export const createRegion = async (payload: CreateCategoryRequest): Promise<void> => {
    const { regionStore } = getStore();

    regionStore.setiIsCreatingRegion(true);

    try {
        await regionApi.createRegion(payload);

        // Refresh the regions after creation
        const id = payload.parentId || '';
        await regionStore.fetchRegions(id);
    } catch {
        showMessageModal('error', `Failed to create region with name ${payload.name}`);
    } finally {
        regionStore.setiIsCreatingRegion(false);
    }
};
